import FormField from "./FormField";
import LengthValidator from "./validators/LengthValidator";
import DigitValidator from "./validators/DigitValidator";

export default class NumberField extends FormField {
    constructor(minLength = 0, maxLength = 64, isOptional = false, initialValue = '', feature = undefined) {
        super(isOptional, initialValue, feature);
        this._validators = [new LengthValidator(minLength, maxLength), new DigitValidator()];
    }
}
